import { Component, computed, effect, ElementRef, inject, input, output, viewChild } from '@angular/core';
import { PaymentproviderShort } from '@frontend/masterdata';
import { CommonModule } from '@angular/common';
import { CouponComponent } from '../coupon/coupon.component';
import { ParameterService, PaymentproviderSwitcherComponent } from '@frontend/frontendlib';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-choosepayment-paymentprovider',
  templateUrl: './choosepayment-paymentprovider.component.html',
  styleUrls: ['./choosepayment-paymentprovider.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    CouponComponent,
    PaymentproviderSwitcherComponent
  ]
})
export class ChoosepaymentPaymentproviderComponent {
  public paymentprovider = input.required<PaymentproviderShort>();
  public openPaymentproviderId = input('');
  public togglePaymentProvider = output<string>();
  public sanitizer = inject(DomSanitizer);
  public parameterService = inject(ParameterService);
  public currentPath = computed(() => 
    this.sanitizer.bypassSecurityTrustUrl(
      `${window.location.pathname}?channel=${this.parameterService.queryParams.channel_id}&payment=${this.parameterService.queryParams.payment_id}&paymentprovider=${this.paymentprovider().id}`
    )
  );
  elementView = viewChild.required<ElementRef>('collapsedContent');
  
  public isClosed = true;
  constructor() {
    effect(() => {
      const oldState = this.isClosed;
      this.isClosed = this.paymentprovider().id !== this.openPaymentproviderId();
      if (oldState !== this.isClosed) {
        if (this.isClosed) {
          this.slideUp();
        } else {
          this.slideDown();
        }
      }
    });
  }

  public doTogglePaymentprovider() {
    this.togglePaymentProvider.emit(this.paymentprovider().id);
  }

  showCouponInfo() {
    this.parameterService.coupon_input = true;
  }

  duration = 500;

  get scrollHeight() {
    return this.elementView().nativeElement.scrollHeight;
  }
    
  incrementHeight(progress: number): void {
    this.elementView().nativeElement.style.height = `${this.scrollHeight * progress}px`;
  }

  decrementHeight(progress: number): void {
    this.elementView().nativeElement.style.height = `${this.scrollHeight - progress * this.scrollHeight}px`;
    this.elementView().nativeElement.style.overflow = "hidden";
  }

  slideDown() {
    const start = performance.now();
    const globalthis = this;
    requestAnimationFrame(function animate(time) {
      const runtime = time - start;
      const relativeProgress = runtime / globalthis.duration;
      const process = Math.min(relativeProgress, 1);

      if (process < 1) {
        globalthis.incrementHeight(process);
        requestAnimationFrame(animate);
      }

      if (process === 1) {
        globalthis.elementView().nativeElement.height = "auto";
        globalthis.elementView().nativeElement.overflow = "initial";
      }
    });
  }

  slideUp() {
    const start = performance.now();
    const globalthis = this;
    requestAnimationFrame(function animate(time) {
      const runtime = time - start;
      const relativeProgress = runtime / globalthis.duration;
      const process = Math.min(relativeProgress, 1);
      if (process < 1) {
        globalthis.decrementHeight(process);
        requestAnimationFrame(animate);
      }
      if (process === 1) {
        globalthis.elementView().nativeElement.height = "0";
        globalthis.elementView().nativeElement.overflow = "";
      }
    });
  }
}
